import { useEffect, useState } from "react";
import * as theme from "../theme";
import { useDispatch, useSelector } from "react-redux";
import BackToApplication from "../general/BackToApplication";
import TextField from "@material-ui/core/TextField";
import InfoIcon from "@material-ui/icons/Info";
import CancelIcon from "@material-ui/icons/Cancel";
import Modal from "react-modal";
import PerfectScrollbar from "react-perfect-scrollbar";

import _ from "lodash";

import {
  changeExpandProp,
  editClientNeeds,
  updateClientNeeds,
  updateClientNeed,
  getclientNeedsEdit,
  getCompareViewData,
  getCompareViewExpand,
  getCompareViewExpandLoc,
  getCompareViewRows,
  getInsurerModalInfo,
  showInsurerInfoModal,
  closeInsurerInfoModal,
  getExpandableBoolean,
  getProspectidFromCompareView,
  getCols,
  getCoverInfoFromCoverId,
  getClientNeedsFromCoverId,
  getAllClientNeeds,
  getResponseDetailsFromInsurerCodeandCoverId,
  getResponseDetailsFromInsurerCodesandCoverId,
  getResponseDetailsFromInsurerCodesCoverIdAndLocationId,
  getCompareViewResponseDetails,
  getCoverTypeInfoFromCoverId,
  getInsuerInforUsingCode,
  getPossibleApiStatusValueFromCompareView,
  getExpandableBooleanForLocation,
  changeLocationExpandProp,
  getResponseDetailsFromInsurerCodeandCoverIdAndLocationId,
  getCovermatchDetailsFromInsurerCodeandCoverId,
  getCovermatchDetailsFromInsurerCodeandCoverIdAndLocationId,
  getResponseIdFromCompareView,
  getQuoteyScore,
  getToShowGreenBarForQouteyScore,
  getCompareViewStateData,
} from "../store/compareview";
import {
  PossibleApiStatusValues,
  PossibleCols,
  PossibleRowTypesForViewCompareTable,
} from "../store/helperfuncs";
import PlusIcon from "../formnavigation/PlusIcon";
import MinusIcon from "../formnavigation/MinusIcon";
import AutoFitTextDiv from "../general/AutoFitTextDiv";
import {
  changeDoNotShowNavigationButtons,
  changeHelpOrTipText,
  getLanguageCode,
} from "../store/components";
import { makeStyles } from "@material-ui/core/styles";
import InsurerLogo from "../general/InsurerLogo";

import { formatter, CurrencyCovertor, DisplayCoverValue } from "../general/Price";
import LoadingBars from "../general/LoadingBars";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import {
  GREEN_AS_PER_BACKEND,
  PURPLE_AS_PER_BACKEND,
  RED_AS_PER_BACKEND,
} from "../store/businesslogic/dict";
import ColorDotCompareView from "../general/ColorDotCompareView";
import {
  getCoverIdForCoverageLevel,
  getCoverIdForExpiryDate,
  getCoverIdForQuoteyScore,
  getRowIdForPrice,
} from "../store/businesslogic/hardwiredlogic";
import ScoreBar from "../general/ScoreBar";
import moment from "moment";
import { Typography, Switch } from "@material-ui/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import UnfoldMoreIcon from "@material-ui/icons/UnfoldMore";
import UnfoldLessIcon from "@material-ui/icons/UnfoldLess";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const MainArea = ({ isProspectIdEncrypted = false }) => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const prospectid = useSelector(getProspectidFromCompareView);
  const responseid = useSelector(getResponseIdFromCompareView);
  const rows = useSelector(getCompareViewRows);
  const compareViewStateData = useSelector(getCompareViewStateData);
  const InsurerModalInfo = useSelector(getInsurerModalInfo);
  const [showEmptyRows, setShowEmptyRows] = useState(false); // State to keep track of toggle
  const dispatch = useDispatch();
  const [filterText, setFilterText] = useState(""); // State for the filter input text

  const [searchTextHelper, setSearchTextHelper] = useState( // Renamed to avoid confusion
    translations[languagepreference].pressEnterToExecute
  );

  useEffect(() => {
    if (isProspectIdEncrypted === true) {
      dispatch(changeDoNotShowNavigationButtons({ value: true }));
    }
  }, []);
  const navigate = useNavigate();
  const divHeights = {
    first: "10%",
    second: "",
    header: "10%",
    main: "90%",
  };
  divHeights.second = `calc(100% - ${divHeights.first})`;
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        flexDirection: "column",
      }}
    >
      {isProspectIdEncrypted === false ? (
        <div style={{ position: "absolute", left: 10 }}>
          <BackToApplication
            text={translations[languagepreference].backToInsurerHub}
            onClick={() => {
              navigate(`/quotes?id=${prospectid}`);
            }}
          ></BackToApplication>
        </div>
      ) : (
        <></>
      )}

      <div style={{ height: divHeights.first }}>
        <HeadingAndBackButton responseid={responseid}></HeadingAndBackButton>
      </div>
      <TextField
        helperText={searchTextHelper}
        id="demo-helper-text-misaligned"
        label={translations[languagepreference].filterForCovers}
        style={{
          position: "absolute",
          right: "2%",
        }}
        onChange={(event) => { 
          const currentText = event.target.value;
          setFilterText(currentText);
           setSearchTextHelper( currentText ? translations[languagepreference].pressEnterToSearch : translations[languagepreference].pressEnterToExecute);
        }}
        // onBlur={(event) => {
        //   let searchText = event.target.value.toLowerCase();
        //   let filteredList = rows.filter((r) =>
        //     r?.name[languagepreference]?.toLowerCase().includes(searchText)
        //   );
        //   setFilter(filteredList);
        // }}
        // onKeyPress={(ev) => {
        //   setsearchText(translations[languagepreference].pressEnterToSearch);
        //   let searchText = ev.target.value.toLowerCase();
        //   let filteredList = rows.filter((r) =>
        //     r?.name[languagepreference]?.toLowerCase().includes(searchText)
        //   );
        //   if (filteredList.length == 0) {
        //     setsearchText("No results found");
        //   }
        //   if (ev.key === "Enter") {
        //     ev.preventDefault();

        //     setFilter(filteredList);
        //   }
        // }}
      />

      <div
        style={{
          height: divHeights.second,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CompareTable
          prospectid={prospectid}
          responseid={responseid}
          isProspectIdEncrypted={isProspectIdEncrypted}
          filterText={filterText}
        ></CompareTable>
      </div>
      <InsurerInfoModal {...InsurerModalInfo}></InsurerInfoModal>
    </div>
  );
};

const HeadingAndBackButton = ({ responseid }) => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        fontSize: "3vmin",
        justifyContent: "center",
        fontFamily: "GibsonSemiBd",
        letterSpacing: 1,
        textAlign: "center",
      }}
    >
      {responseid
        ? translations[languagepreference].viewOffer
        : translations[languagepreference].compareOffer}
    </div>
  );
};

const useStyles = makeStyles(theme.customMaterialUIClassForScrollBar);

const CompareTable = ({
  prospectid,
  responseid,
  isProspectIdEncrypted,
  filterText,
}) => {
  const dispatch = useDispatch();
  const [showEmptyRows, setShowEmptyRows] = useState(false); // State to keep track of toggle

  useEffect(() => {
    dispatch(
      getCompareViewData({ prospectid, responseid, isProspectIdEncrypted })
    );
  }, []);

  const stateRows = useSelector(getCompareViewRows);
  const expand = useSelector(getCompareViewExpand);
  const compareViewStateData = useSelector(getCompareViewStateData);
  const [buildingData, setBuildingData] = useState();
  const [buildingExist, setBuildingExist] = useState(true);
  const [rows, setRows] = useState([]);
  const cols = useSelector(getCols);
  const possibleApiStatusValue = useSelector(
    getPossibleApiStatusValueFromCompareView
  );
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  useEffect(() => {
    
    //flag to update rows or keep orginal depends if buildings exist or not
    let shouldUpdateRows = true;
    const propertyText =
    languagepreference=== "fr" ? "Propriété" : "Property";
    const locationText =
    languagepreference === "fr" ? "Emplacement" : "Location";
    if (compareViewStateData && stateRows.length > 0 && rows.length === 0) {
      // Process each response
      compareViewStateData.responses.forEach((response) => {
        const tempLocationsData = response.locations;
        const newRows = [];
        if (tempLocationsData) {
          stateRows.forEach((rowData) => {
            if (rowData.rowtype === "locationheading" && rowData.locationid) {
              const locationData = tempLocationsData[rowData.locationid] || {};
              let buildingsData = locationData.buildings || {};

              if (rowData.numberOfBuildings) {
                buildingsData = _.pick(
                  buildingsData,
                  _.range(0, rowData.numberOfBuildings)
                );
              }

              // Process buildings data if available
              Object.keys(buildingsData).forEach((buildingIndex) => {
                const building = buildingsData[buildingIndex];
                let clonedHeader = _.cloneDeep(rowData);
                clonedHeader.buildingid = parseInt(buildingIndex);
                clonedHeader.name += ` - ${propertyText} - ${
                  clonedHeader.buildingid + 1
                }`;
                newRows.push(clonedHeader);

                // Append locationdatarow entries under the current heading
                stateRows.forEach((innerRow) => {
                  if (
                    innerRow.rowtype === "locationdatarow" &&
                    innerRow.locationid === rowData.locationid
                  ) {
                    let clonedDataRow = _.cloneDeep(innerRow);
                    clonedDataRow.buildingid = clonedHeader.buildingid;
                    const buildingCoverValue = building[innerRow.id];

                    if (buildingCoverValue || buildingCoverValue === 0) {
                      clonedDataRow.covervalue = buildingCoverValue;
                    } else if (buildingCoverValue === null) {
                      clonedDataRow.covervalue = "-";
                    }
                    newRows.push(clonedDataRow);
                  }
                });
              });

              // If no buildings, keep the original logic for locations without buildings
              if (Object.keys(buildingsData).length === 0) {
                setBuildingExist(false);
               
                shouldUpdateRows = false;
              }
            } else if (rowData.rowtype !== "locationdatarow") {
              newRows.push(rowData); // Handle other row types here, if any
            }
          });
        } else {
          shouldUpdateRows = false;
        }
        if (shouldUpdateRows) {

          const updatedStateRows = newRows.map((row) => {
            if (row.rowtype === "locationheading") {
              return {
                ...row,
                name: row.name.replace(/^Location/, locationText)
              };
            }
            return row;
          });
          setRows(updatedStateRows);
        } else {

          const updatedStateRows = stateRows.map((row) => {
            if (row.rowtype === "locationheading") {
              return {
                ...row,
                name: row.name.replace(/^(Location|Emplacement)/, locationText)
              };
              
            }
            return row;
          });
          setRows(updatedStateRows);
        }
        // Update the rows state for each response
      });
    }
    if(rows.length){
     var tempRows=rows.map((row) => {
        if (row.rowtype === "locationheading") {
          return {
            ...row,
            name: row.name.replace(/^(Location|Emplacement)/, locationText)
          };
          
        }
        return row;
      });
      setRows(tempRows)
    }
  }, [compareViewStateData, stateRows,languagepreference]);

  const classes = useStyles();

  const colslength = cols.length;

  const widthDecider = () => {
    if (colslength >= 6) return 95;
    if (colslength >= 5) return 90;
    if (colslength >= 4) return 80;
    return 50;
  };

  const cellwidthdecider = ({ colslength }) => {
    return `${100 / colslength}%`;
  };

  const { coverExpand } = useSelector((state) => state.entities.compareview);
  const baseHeight = 4;
  const isExpanded = coverExpand?.[3] || false;

  const { totalCount = 0 } = useSelector(
    (state) => state.entities.classMapping?.prospectClasses?.data ?? {}
  );

  return (
    <>
      {possibleApiStatusValue === PossibleApiStatusValues.loading ? (
        <div
          style={{
            width: "10%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <LoadingBars
            type={"bars"}
            color={theme.COLORS.secondary_orange}
          ></LoadingBars>
        </div>
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              width: `${widthDecider()}%`,
              height: "9vh",
              paddingRight: theme.SCALES.scrollbarThickness,
            }}
          >
            <TableHeaderRowType
              cellwidth={cellwidthdecider({ colslength: colslength })}
              toggleShowEmpty={{
                showEmptyRows: showEmptyRows,
                setShowEmptyRows: function (rowStatus) {
                  setShowEmptyRows(rowStatus);
                },
              }}
            ></TableHeaderRowType>
          </div>
          <div
            style={{
              width: `${widthDecider()}%`,
              paddingRight: theme.SCALES.scrollbarThickness,
              paddingLeft: 1,
              position: "absolute",
              top: "8vh",
            }}
          >
            <div
              style={{
                width: "100%",
                backgroundColor: theme.COLORS.tertiary_lightbackground,
              }}
            >
              <DataRowType
                row={rows[getRowIdForPrice({ rows: [...rows] })]}
                // row={rows[5]}
                cellwidth={cellwidthdecider({ colslength: colslength })}
                visible={true}
                showEmptyRows={showEmptyRows}
              ></DataRowType>
            </div>
          </div>

          <div
            className={classes.responses}
            style={{
              width: `${widthDecider()}%`,
              height: "100%",
              overflow: "auto",
              paddingTop: "4vh",
            }}
          >
            {rows.map((row, index) => (
              <EachRow
                key={index}
                row={row}
                cellwidth={cellwidthdecider({ colslength: colslength })}
                filterText={filterText}
                showEmptyRows={showEmptyRows}
              ></EachRow>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const EachRow = ({ row, cellwidth, filterText, showEmptyRows }) => {
  const { rowtype } = row;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const searchTextLower = filterText?.trim().toLowerCase() || "";
  let isVisible = true; // Assume visible by default
  const covertypeinfo = useSelector(getCoverTypeInfoFromCoverId({ covertypecode: row.covertypecode }));

  if (searchTextLower.length > 0) { // Only filter if there's search text
    const rowName = row?.name?.[languagepreference] || "";
    const rowNameLower = rowName.toLowerCase();

    // Check if the current row's name includes the search text
    if (!rowNameLower.includes(searchTextLower)) {
       // If name doesn't match, check if it's a heading and if the *type* name matches
       let typeNameMatches = false;
       if (rowtype === PossibleRowTypesForViewCompareTable.CCHEADING && row.covertypecode) {
          //  const covertypeinfo = useSelector(getCoverTypeInfoFromCoverId({ covertypecode: row.covertypecode }));
           typeNameMatches = covertypeinfo?.name?.[languagepreference]?.toLowerCase().includes(searchTextLower);
       }
      

       if (!typeNameMatches) { // Only hide if neither name nor relevant type name matches
         isVisible = false;
       }
    }
  }




  if (!isVisible) {
    return null;
  }
  const deciderDiv = () => {
    

   if (rowtype === PossibleRowTypesForViewCompareTable.DATAROW) {
     return (
       <DataRowType
         row={row}
         cellwidth={cellwidth}
         showEmptyRows={showEmptyRows}
       ></DataRowType>
     );
   }
   if (rowtype === PossibleRowTypesForViewCompareTable.LOCATIONDATAROW) {
     return (
       <LocationDataRowType
         row={row}
         cellwidth={cellwidth}
         showEmptyRows={showEmptyRows}
       ></LocationDataRowType>
     );
   }
   if (rowtype === PossibleRowTypesForViewCompareTable.CCHEADING) {
    
     return (
       <CoverTypeCodeHeading
         row={row}
         cellwidth={cellwidth}
         showEmptyRows={showEmptyRows}
         languagepreference={languagepreference}
       ></CoverTypeCodeHeading>
     );
   }
   if (rowtype === PossibleRowTypesForViewCompareTable.LOCATIONHEADING) {

     return (
       <LocationTypeCodeHeading
         row={row}
         cellwidth={cellwidth}
         showEmptyRows={showEmptyRows}
         languagepreference={languagepreference}
       ></LocationTypeCodeHeading>
     );
   }
   return null; 
 };
  return <div style={{ width: "100%" }}>{deciderDiv()}</div>;
};

const TableHeaderRowType = ({ row, cellwidth, toggleShowEmpty }) => {
  var cols = useSelector(getCols);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  // cols = cols.map((data) => {});

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        fontSize: "1.7vmin",
        fontWeight: "bold",
        letterSpacing: 1,
      }}
    >
      {cols.map((col, index) => (
        <HeadingCellCompareView
          key={index}
          index={index}
          colslength={cols.length}
          cellwidth={cellwidth}
          toggleShowEmpty={toggleShowEmpty}
          value={
            col?.heading?.[languagepreference] ? (
              col?.heading[languagepreference]
            ) : (
              <InsurerName insurercode={col.insurercode}></InsurerName>
            )
          }
        ></HeadingCellCompareView>
      ))}
    </div>
  );
};

const HeadingCellCompareView = ({
  value,
  colslength,
  index,
  cellwidth,
  toggleShowEmpty,
}) => {
  // Determine if this is the first, second, or last column
  const isFirstCol = index === 0;
  const isSecondCol = index === 1;
  const isLastCol = index === colslength - 1;
  const [expandAll, setExpandAll] = useState(true);
  // Retrieve necessary data from the store
  const dispatch = useDispatch();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const storeClientNeeds = useSelector(getclientNeedsEdit);
  const clientNeedsBtnTxt = storeClientNeeds
    ? translations[languagepreference].save
    : translations[languagepreference].edit;
  const expand = useSelector(getCompareViewExpand);
  const expandLoc = useSelector(getCompareViewExpandLoc);
  return (
    <div
      style={{
        width: cellwidth,
        height: "100%",
        fontFamily: "GibsonRegular",
        borderLeft: `1px solid grey`,
        borderRight: "1px solid grey",
        borderBottom: "1px solid grey",
        borderTop: "1px solid grey",
        display: "block",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        backgroundColor:
          isFirstCol || isSecondCol
            ? theme.COLORS.dark_navy_blue
            : theme.COLORS.tertiary_lightbackground,
        color:
          isFirstCol || isSecondCol ? "white" : theme.COLORS.dark_navy_blue,
        borderTopLeftRadius: isFirstCol ? 7 : 0,
        borderTopRightRadius: isLastCol ? 7 : 0,
      }}
    >
      <span>{value}</span>

      {(value == "Client Needs"||value ==="Besoins du client") && (
        <button
          style={{
            marginLeft: "30px",
            fontSize: "16px",
            backgroundColor: "rgb(104, 102, 122)",
            color: "white",
            borderRadius: "18%",
          }}
          onClick={() => {
            if (storeClientNeeds) {
              dispatch(updateClientNeeds());
            }
            dispatch(editClientNeeds());
          }}
        >
          {clientNeedsBtnTxt}
        </button>
      )}

      {(value === "Cover Name"||value ==="Couverature") && (
        <>
          <Tooltip title="Toggle visibility of empty rows">
            <IconButton
              onClick={() => {
                toggleShowEmpty.setShowEmptyRows(
                  !toggleShowEmpty.showEmptyRows
                );
              }}
            >
              {toggleShowEmpty.showEmptyRows ? (
                <VisibilityIcon style={{ color: "white" }} />
              ) : (
                <VisibilityOffIcon style={{ color: "white" }} />
              )}
            </IconButton>
          </Tooltip>
          <Tooltip title="Expand or Collapse all groups">
            <IconButton
              onClick={() => {
                setExpandAll((prevState) => {
                  console.log(expandLoc);
                  for (let covertypecode in expand) {
                    if (covertypecode == "LOCATION") {
                      for (let locationid in expandLoc) {
                        for (let buildingid in expandLoc[locationid]) {
                          if (isNaN(buildingid)) {
                            dispatch(
                              changeLocationExpandProp({
                                locationid,
                                changedvalue: !prevState,
                              })
                            );
                          } else {
                            dispatch(
                              changeLocationExpandProp({
                                locationid,
                                changedvalue: !prevState,
                                buildingid,
                              })
                            );
                          }
                        }
                      }
                    }
                    dispatch(
                      changeExpandProp({
                        covertypecode,
                        changedvalue: !prevState,
                      })
                    );
                  }
                  return !prevState;
                });
              }}
            >
              {expandAll ? (
                <UnfoldLessIcon style={{ color: "white" }} />
              ) : (
                <UnfoldMoreIcon style={{ color: "white" }} />
              )}
            </IconButton>
          </Tooltip>
        </>
      )}
    </div>
  );
};

const InsurerName = ({ insurercode }) => {
  const insname = useSelector(getInsuerInforUsingCode({ insurercode }));
  const dispatch = useDispatch();
  return (
    <div
      style={{
        color: theme.COLORS.primary_navyblue,
      }}
    >
      <div>
        <InfoIcon
          fontSize="small"
          style={{
            float: "right",
            marginRight: "3%",
            marginTop: "7px",
          }}
          onClick={() => {
            dispatch(showInsurerInfoModal(insname));
          }}
        ></InfoIcon>
      </div>
      <div style={{ height: "5vmin" }}>
        <InsurerLogo
          code={insurercode}
          img={insname?.image}
          waitSeconds={0}
        ></InsurerLogo>
      </div>
      <div style={{ fontSize: "1.5vmin" }}>{insname?.name}</div>
    </div>
  );
};

// Example usage within a mapping function
const translateClientNeed = (need, lang) => {
  if (need === "Included") {
    return translations[lang].included;
  } else if (need === "Not Included") {
    return translations[lang].notIncluded;
  } else if (need === "Required") {
    return translations[lang].required;
  } else if (need === "Not required") {
    return translations[lang].notRequired;
  }
  // Fallback: return the original need if no translation matches.
  return need;
};

const DataRowType = ({ row, cellwidth, visible, showEmptyRows }) => {
  let covertypecode = null;
  let id = null;
  let coverid = null;
  try {
    covertypecode = row.covertypecode;
    id = row.id;
    coverid = id;
  } catch (e) {}

  const cols = useSelector(getCols);
  const expandable = useSelector(getExpandableBoolean({ covertypecode }));
  const [rowheightx, setrowHeight] = useState("4vh");
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  var displayStyle = "flex";
  var clientneed = useSelector(getClientNeedsFromCoverId({ coverid }));
  clientneed = translateClientNeed(clientneed, languagepreference);
  var insurercodes = cols.map((x) => x?.insurercode).filter((x) => x);
  const insurerResponses = useSelector(
    getResponseDetailsFromInsurerCodesandCoverId({ coverid, insurercodes })
  );

  const { coverExpand } = useSelector((state) => state.entities.compareview);
  const isExpanded = coverExpand?.[coverid] || false;

  const { totalCount = 0 } = useSelector(
    (state) => state.entities.classMapping?.prospectClasses?.data ?? {}
  );

  // if (
  //   row?.covertypecode == "SUBJT" &&
  //   ([null, ""].includes(clientneed) || true) &&
  //   insurerRepsonses.filter((x) => !["", "-"].includes(x)).length == 0
  // ) {
  //   displayStyle = "none";
  // }

  if (!showEmptyRows) {
    const isDataEmptyOrDash = (data) =>
      data === "" || data === "-" || data === null || ['Not Included', 'Not Required'].includes(data) ;
    if (
      isDataEmptyOrDash(clientneed) &&
      insurerResponses.every(isDataEmptyOrDash)
    ) {
      displayStyle = "none";
    }
  } else {
    displayStyle = "flex";
  }

  return (
    <>
      {expandable || visible ? (
        <div
          style={{ width: "100%", height: rowheightx, display: displayStyle }}
        >
          {cols.map((col, index) => (
            <EachDataRow
              key={index}
              col={col}
              coverid={id}
              colslength={cols.length}
              cellwidth={cellwidth}
              setrowHeight={setrowHeight}
              rowheightx={rowheightx}
            ></EachDataRow>
          ))}
        </div>
      ) : null}
    </>
  );
};

const LocationDataRowType = ({ row, cellwidth, visible, showEmptyRows }) => {
  let covertypecode = null;
  let id = null;
  let locationid = null;
  let buildingid = null;
  var displayStyle = "flex";
  const { coverExpand } = useSelector((state) => state.entities.compareview);
  const baseHeight = 4;
  const isExpanded = coverExpand?.[row.id] || false;

  const { totalCount = 0 } = useSelector(
    (state) => state.entities.classMapping?.prospectClasses?.data ?? {}
  );

  try {
    covertypecode = row.covertypecode;
    id = row.id;
    locationid = row.locationid;
    buildingid = row.buildingid || 0;
  } catch (e) {}
  const cols = useSelector(getCols);
  var clientneed = useSelector(getClientNeedsFromCoverId({ id }));
  var insurercodes = cols.map((x) => x?.insurercode).filter((x) => x);
  const insurerResponses = useSelector(
    getResponseDetailsFromInsurerCodesCoverIdAndLocationId({
      insurercodes,
      coverid: id,
      locationid,
      buildingid,
    })
  );

  const expandable = useSelector(
    getExpandableBooleanForLocation({ locationid, buildingid })
  );

  if (!showEmptyRows) {
    const isDataEmptyOrDash = (data) =>
      data === "" || data === "-" || data === null;
    if (
      isDataEmptyOrDash(clientneed) &&
      insurerResponses.every(isDataEmptyOrDash)
    ) {
      displayStyle = "none";
    }
  } else {
    displayStyle = "flex";
  }

  return (
    <>
      {expandable ? (
        <div style={{ width: "100%", height: "4vh", display: displayStyle }}>
          {cols.map((col, index) => (
            <EachDataRow
              key={index}
              col={col}
              coverid={id}
              colslength={cols.length}
              cellwidth={cellwidth}
              locationtype={true}
              locationid={locationid}
              row={row}
              buildingid={buildingid}
            ></EachDataRow>
          ))}
        </div>
      ) : null}
    </>
  );
};
function removeBrackets(str) {
  if (typeof str !== "string") {
    // If not a string, return the input unchanged or handle as needed
    return str;
  }
  return str.replace(/\[\[|\]\]/g, "");
}
const EachDataRow = ({
  col,
  coverid,
  colslength,
  cellwidth,
  locationtype,
  row,
  locationid,
  setrowHeight,
  rowheightx,
  buildingid,
}) => {
  if (col.type === PossibleCols.COVERINFO) {
    return (
      <CoverInfoCell
        col={col}
        coverid={coverid}
        colslength={colslength}
        cellwidth={cellwidth}
        rowheightx={rowheightx}
      ></CoverInfoCell>
    );
  }

  if (col.type === PossibleCols.CLIENTNEEDS) {
    if (locationtype) {
      // TODO: function in clientneeds.js "calculateClientNeed" in backend should return
      //       clientneeds including location object in which for each location there
      //       are different client needs. If that thing is changed, we can know the clientneeds
      //       for each location and hence return the cell as per the data but untill the function
      //       got change in backend, general ClientNeedCell will be returned.

      return (
        <ClientNeedCell
          col={col}
          coverid={coverid}
          colslength={colslength}
          cellwidth={cellwidth}
          locationid={locationid}
          buildingid={buildingid}
        ></ClientNeedCell>
      );
    }
    return (
      <ClientNeedCell
        col={col}
        coverid={coverid}
        colslength={colslength}
        cellwidth={cellwidth}
        rowheightx={rowheightx}
      ></ClientNeedCell>
    );
  }

  if (col.type === PossibleCols.INSURER) {
    if (locationtype) {
      return (
        <InsurerInfoCellForLocation
          col={col}
          coverid={coverid}
          colslength={colslength}
          cellwidth={cellwidth}
          locationtype={locationtype}
          row={row}
          buildingid={buildingid}
        ></InsurerInfoCellForLocation>
      );
    }
    return (
      <InsurerInfoCell
        col={col}
        coverid={coverid}
        colslength={colslength}
        cellwidth={cellwidth}
        locationtype={locationtype}
        setrowHeight={setrowHeight}
        rowheightx={rowheightx}
      ></InsurerInfoCell>
    );
  }

  return null;
};
const InsurerInfoCellForLocation = ({
  col,
  coverid,
  colslength,
  cellwidth,
  row,
  buildingid,
}) => {
  const { insurercode } = col;

  const { locationid, covervalue } = row;
  const cvalue = useSelector(
    getResponseDetailsFromInsurerCodeandCoverIdAndLocationId({
      coverid,
      insurercode,
      locationid,
      buildingid,
    })
  );

  //

  const covermatchcolor = useSelector(
    getCovermatchDetailsFromInsurerCodeandCoverIdAndLocationId({
      coverid,
      insurercode,
      locationid,
      buildingid,
    })
  );

  return (
    <div
      style={{
        width: cellwidth,
        height: "100%",
        fontFamily: "GibsonRegular",
        borderLeft: `1px solid lightgrey`,
        borderRight: "1px solid lightgrey",
        borderBottom: "1px solid lightgrey",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontSize: "1.6vmin",
      }}
    >
      <div style={{ width: "5%" }}></div>
      <div
        style={{
          width: "85%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
        }}
      >
        {buildingid === undefined
          ? CurrencyCovertor(cvalue)
          : CurrencyCovertor(removeBrackets(cvalue))}
        {/* {covervalue} */}
      </div>
      <div style={{ width: "10%" }}>
        {covermatchcolor ? (
          <ColorDotCompareView
            covermatchcolor={covermatchcolor}
          ></ColorDotCompareView>
        ) : null}
      </div>
    </div>
  );
};
const dotColorDecider = (text) => {
  if (text === PURPLE_AS_PER_BACKEND) {
    return theme.COLORS.purple_dot;
  }
  if (text === RED_AS_PER_BACKEND) {
    return theme.COLORS.red_dot;
  }
  if (text === GREEN_AS_PER_BACKEND) {
    return theme.COLORS.green_dot;
  }
  return "white";
};
const InsurerInfoCell = ({
  col,
  coverid,
  colslength,
  cellwidth,
  setrowHeight,
  rowheightx,
  
}) => {
  const { insurercode } = col;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const cvalue = useSelector(
    getResponseDetailsFromInsurerCodeandCoverId({ coverid, insurercode })
  );
 

  const covermatchcolor = useSelector(
    getCovermatchDetailsFromInsurerCodeandCoverId({ coverid, insurercode })
  );
  const coverInfo = useSelector(getCoverInfoFromCoverId({ coverid }));
  var overflow = "hidden";

  let commonStyle = {
    width: cellwidth,
    height: rowheightx ? "100%" : null,
    fontFamily: "GibsonRegular",
    borderLeft: `1px solid lightgrey`,
    borderRight: "1px solid lightgrey",
    borderBottom: "1px solid lightgrey",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontSize: "1.6vmin",
    overflow: overflow,
  };

  if (coverid === getCoverIdForQuoteyScore()) {
    return (
      <div style={commonStyle}>
        <QuoteyScoreCompareView
          insurercode={insurercode}
        ></QuoteyScoreCompareView>
      </div>
    );
  }

  if (coverid === getCoverIdForCoverageLevel()) {
    return (
      <div style={commonStyle}>
        <CovermatchScoreCompareView
          cvalue={cvalue}
        ></CovermatchScoreCompareView>
      </div>
    );
  }

  if (coverid === getCoverIdForExpiryDate()) {
    return (
      <div style={commonStyle}>
        {cvalue && moment(cvalue)
    .locale(languagepreference)
    .format("DD MMM YYYY")}
        
        {/* moment(new Date(cvalue), "DD/MM/YYYY").format("DD MMM YYYY")} */}
      </div>
    );
  }

  return (
    <div style={commonStyle}>
      <CommonCoverValues
        cvalue={cvalue}
        covermatchcolor={covermatchcolor}
        coverinfo={coverInfo}
        insurercode={insurercode}
      ></CommonCoverValues>
    </div>
  );
};

const CovermatchScoreCompareView = ({ cvalue }) => {
  return (
    <div
      style={{
        width: "60%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {" "}
      <ScoreBar score={cvalue} height="65%"></ScoreBar>
      {/* {quoteyScoreValue} */}
    </div>
  );
};

const QuoteyScoreCompareView = ({ insurercode }) => {
  const quoteyScoreValue = useSelector(getQuoteyScore({ insurercode }));
  const showGreenBar = useSelector(
    getToShowGreenBarForQouteyScore({ insurercode })
  );

  return (
    <div
      style={{
        width: "60%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {" "}
      <ScoreBar
        score={quoteyScoreValue}
        height="65%"
        color={showGreenBar ? theme.COLORS.green_bar : false}
      ></ScoreBar>
      {/* {quoteyScoreValue} */}
    </div>
  );
};

const CommonCoverValues = ({
  cvalue,
  covermatchcolor,
  coverinfo,
  insurercode,
}) => {
  const textLength = 34;
  const display = "flex";
  const textAlign = "center";
  const fontSize = "1.6vmin";
  var clickable = false;

  var cursor = "default";
  var title = "";
  if (cvalue?.length > textLength) {
    title = cvalue;
    cvalue = cvalue.slice(0, textLength) + "...";
    clickable = true;
    cursor = "pointer";
  }
  const dispatch = useDispatch();
  const insname = useSelector(getInsuerInforUsingCode({ insurercode }));
  return (
    <>
      <div style={{ width: "5%" }}></div>
      <div
        style={{
          width: "85%",
          height: "100%",
          display: display,
          justifyContent: "center",
          textAlign: textAlign,
          alignItems: "center",
          wordWrap: "break-word",
          whiteSpace: "pre-line",
          fontSize: fontSize,
          cursor: cursor,
        }}
        onClick={() => {
          if (clickable && coverinfo.name["en"] == "Comment") {
            dispatch(showInsurerInfoModal(insname));
          }
        }}
        title={title}
      >
        {DisplayCoverValue(cvalue, coverinfo)}
      </div>
      <div style={{ width: "10%" }}>
        {covermatchcolor ? (
          <ColorDotCompareView
            covermatchcolor={covermatchcolor}
          ></ColorDotCompareView>
        ) : null}
      </div>
    </>
  );
};

const ClientNeedCell = ({
  col,
  coverid,
  colslength,
  cellwidth,
  locationid,
  rowheightx,
  buildingid,
}) => {
  let dispatch = useDispatch();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  var displayStyle = "flex";
  var clientneed = useSelector(getClientNeedsFromCoverId({ coverid }));
  clientneed = translateClientNeed(clientneed, languagepreference);
  // var clientneed = useSelector(getClientNeedsFromCoverId({ coverid }));
  const coverinfo = useSelector(getCoverInfoFromCoverId({ coverid }));
  if (locationid && Array.isArray(clientneed)) {
    clientneed = clientneed[locationid - 1];
    if (Array.isArray(clientneed)) {
      if (buildingid != undefined) {
        clientneed = clientneed[buildingid];
      } else clientneed = clientneed[0];
    }
  }
  const storeclientNeeds = useSelector(getclientNeedsEdit);
  const [text, setText] = useState(
    CurrencyCovertor(clientneed, coverinfo)
      ? CurrencyCovertor(clientneed, coverinfo)
      : ""
  );
  const heightcell = rowheightx ? "100%" : null;
  const styleObj = {
    width: cellwidth,
    height: heightcell,
    fontFamily: "GibsonRegular",
    borderLeft: `1px solid lightgrey`,
    borderRight: "1px solid lightgrey",
    borderBottom: "1px solid lightgrey",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    backgroundColor: theme.COLORS.tertiary_ligthindigo,
    fontSize: "1.6vmin",
  };
  if (storeclientNeeds) {
    return (
      <>
        <input
          style={styleObj}
          list="clientNeedOptionsList"
          onChange={(e) => {
            setText(e.target.value);
            dispatch(updateClientNeed({ [coverid]: e.target.value }));
          }}
          value={text}
        ></input>
        <datalist id="clientNeedOptionsList">
          <option value="Include"></option>
          <option value="Not required"></option>
          <option value="Limitation"></option>
          <option value="Declined"></option>
        </datalist>
      </>
    );
  }
  return <div style={styleObj}>{text}</div>;
};

const CoverInfoCell = ({ col, coverid, colslength, cellwidth, rowheightx }) => {
  var tempCoverInfo = useSelector(getCoverInfoFromCoverId({ coverid }));
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  // const coverinfo = {
  //   ...tempCoverInfo,
  //   name: { en: tempCoverInfo?.name, fr: tempCoverInfo?.frname },
  //   definition: {
  //     en: tempCoverInfo?.definition,
  //     fr: tempCoverInfo?.frdefinition,
  //   },
  // };
  const coverinfo = tempCoverInfo;
  const [hover, setHover] = useState(false);
  const [bgColor, setBgColor] = useState("inherit");
  const dispatch = useDispatch();
  const heightcell = rowheightx ? "100%" : null;
  return (
    <div
      style={{
        width: cellwidth,
        height: heightcell,
        fontFamily: "GibsonRegular",
        borderLeft: `1px solid lightgrey`,
        borderRight: "1px solid lightgrey",
        borderBottom: "1px solid lightgrey",
        display: "flex",
        // justifyContent: "center",
        alignItems: "center",
        textAlign: "left",
        paddingLeft: "2.3vmin",
        paddingRight: "2.3vmin",
        fontSize: "1.6vmin",
        backgroundColor: bgColor,
      }}
      onMouseOver={() => {
        setBgColor(theme.COLORS.secondary_orange);
        dispatch(
          changeHelpOrTipText(
            `<span style="color:${theme.COLORS.secondary_orange}">` +
              coverinfo?.name[languagepreference] +
              "</span> " +
              `${
                coverinfo?.definition[languagepreference]
                  ? ": " + coverinfo?.definition[languagepreference]
                  : coverinfo?.definition[languagepreference]
              }`
          )
        );
      }}
      onMouseOut={() => {
        setBgColor("inherit");
        // dispatch(changeHelpOrTipText(""));
      }}
    >
      <Typography
        style={{ fontFamily: "GibsonRegular", fontSize: "1.6vmin" }}
        noWrap
      >
        {coverinfo?.parentid !== null
          ? `\u00A0 \u00A0 \u00A0 - ${coverinfo?.name[languagepreference]}`
          : `${coverinfo?.name[languagepreference]}`}
      </Typography>
    </div>
  );
};

const CoverTypeCodeHeading = ({ row, showEmptyRows }) => {
  const { covertypecode, id } = row;
  const rows = useSelector(getCompareViewRows);
  // get the expandable or not for this row
  const expandable = useSelector(getExpandableBoolean({ covertypecode }));
  const allClientneeds = useSelector(getAllClientNeeds())
  // get covertype name
  // const languagecode = useSelector(getLanguageCode);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagecode = BrokerInfo.information.languagepreference;
  const covertypeinfo = useSelector(
    getCoverTypeInfoFromCoverId({ covertypecode })
  );
  const dispatch = useDispatch();

  const handlePlusClick = () => {
    // change the expandable to true
    dispatch(changeExpandProp({ covertypecode, changedvalue: true }));
  };

  const handleMinusClick = () => {
    // change the expandable to true
    dispatch(changeExpandProp({ covertypecode, changedvalue: false }));
  };
  var display = "flex";
  const cols = useSelector(getCols);
  const allResponses = useSelector(getCompareViewResponseDetails());
  var insurercodes = cols.map((x) => x?.insurercode).filter((x) => x);

  // if all the responses are empty, hide the heading of SUBJT
  if (!showEmptyRows) {
    try {
      let subj_ids = rows
        .filter((x) => x.covertypecode == covertypecode)
        .map((x) => x.id)
        .filter((x) => x);
      let clientNeeds = subj_ids
        .map(key => allClientneeds[key])
        .filter((x) => ![null, undefined, "", "-", 'Not Included', 'Not Required', 'Not required'].includes(x));
      const responses = insurercodes
        .flatMap((insurer) =>
          subj_ids.map((subj_id) => allResponses[insurer].covers[subj_id])
        )
        .filter((x) => ![null, undefined, "", "-"].includes(x));
      if (responses.length == 0 && clientNeeds.length == 0) {
        display = "none";
      }
    } catch (e) {
      console.log("Error hiding subtitle");
    }
  }

  return (
    <div
      style={{
        width: "100%",
        height: "6vh",
        border: "1px solid white",
        backgroundColor: theme.COLORS.tertiary_lightblue,
        display: display,
        alignItems: "center",
        paddingLeft: "2vw",
        fontFamily: "GibsonRegular",
        color: theme.COLORS.dark_navy_blue,
        letterSpacing: 1,
        fontSize: "1.7vmin",
      }}
    >
      {covertypeinfo.name[languagecode]}
      <div style={{ paddingLeft: "1vw" }}>
        {expandable ? (
          <MinusIcon
            color={theme.COLORS.secondary_orange}
            onClick={handleMinusClick}
          ></MinusIcon>
        ) : (
          <PlusIcon
            color={theme.COLORS.secondary_orange}
            onClick={handlePlusClick}
          ></PlusIcon>
        )}
      </div>
    </div>
  );
};

const LocationTypeCodeHeading = ({ row, showEmptyRows }) => {
  const { name, locationid, buildingid } = row;
  const dispatch = useDispatch();

  const allResponses = useSelector(getCompareViewResponseDetails());

  const expandable = useSelector(
    getExpandableBooleanForLocation({ locationid, buildingid })
  );

  let displayStyleForThisHeading = "flex"; // Default to show

  if (!showEmptyRows) {
    try {
      let allInsurersAreEffectivelyEmpty = true; // Assume all are empty/no data initially

      if (Object.keys(allResponses || {}).length === 0) {
        allInsurersAreEffectivelyEmpty = true;
      } else {
        for (const insurerCode in allResponses) {
          if (allResponses.hasOwnProperty(insurerCode)) {
            const insurerResponse = allResponses[insurerCode];
            let hasDataForThisInsurer = false;

            if (buildingid != null) {
              const buildingData =
                insurerResponse?.locations?.[locationid]?.buildings?.[buildingid];
              if (buildingData) {
                if (!Object.values(buildingData).every((value) => value === null)) {
                  hasDataForThisInsurer = true;
                }
              }
            } else {
              const locationData = insurerResponse?.locations?.[locationid];
              if (locationData) {

                const relevantEntries = Object.entries(locationData).filter(
                  ([key]) => key !== "covermatches" && key !== "buildings" // Exclude 'buildings' object itself from this check
                );

                if (relevantEntries.length > 0) {
                  if (
                    !relevantEntries.every(([, value]) =>
                      [null, "", "-"].includes(value)
                    )
                  ) {
                    hasDataForThisInsurer = true;
                  }
                }

           
                if (!hasDataForThisInsurer && locationData.buildings) {
                    for (const bId in locationData.buildings) {
                        if (locationData.buildings.hasOwnProperty(bId)) {
                            const bData = locationData.buildings[bId];
                            if (bData && !Object.values(bData).every(value => value === null)) {
                                hasDataForThisInsurer = true;
                                break; // Found data in a building
                            }
                        }
                    }
                }
              }
            }

            if (hasDataForThisInsurer) {
              allInsurersAreEffectivelyEmpty = false; // Found at least one insurer with data
              break; // No need to check other insurers
            }
          }
        }
      }


      if (allInsurersAreEffectivelyEmpty) {
        displayStyleForThisHeading = "none";
      }
    } catch (e) {
      console.error("Error in LocationTypeCodeHeading visibility logic:", e);
  
    }
  }

  const handleMinusClick = () => {
    dispatch(
      changeLocationExpandProp({ locationid, changedvalue: false, buildingid })
    );
  };
  const handlePlusClick = () => {
    dispatch(
      changeLocationExpandProp({ locationid, changedvalue: true, buildingid })
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "6vh",
        border: "1px solid white",
        backgroundColor: theme.COLORS.tertiary_lightblue,
        display: displayStyleForThisHeading,
        alignItems: "center",
        paddingLeft: "2vw",
        fontFamily: "GibsonRegular",
        color: theme.COLORS.dark_navy_blue,
        letterSpacing: 1,
        fontSize: "1.7vmin",
      }}
    >
      {name}
      <div style={{ paddingLeft: "1vw" }}>
        {expandable ? (
          <MinusIcon
            color={theme.COLORS.secondary_orange}
            onClick={handleMinusClick}
          />
        ) : (
          <PlusIcon
            color={theme.COLORS.secondary_orange}
            onClick={handlePlusClick}
          />
        )}
      </div>
    </div>
  );
}

const InsurerInfoModal = (props) => {
  return (
    <Modal
      size="md"
      isOpen={props?.toggleInsurerInfoModel}
      ariaHideApp={false}
      shouldCloseOnEsc={false}
      centered
      style={{
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: theme.COLORS.rgba_primary_navyblue,
        },
        content: {
          height: "55vh",
          width: "40vw",
          position: "absolute",
          top: "15vh",
          left: "25vw",
          background: "#eef3f6",
          WebkitOverflowScrolling: "touch",
          border: "8px solid " + theme.COLORS.primary_navyblue,
          borderRadius: "20px",
          padding: 0,
          overflow: "hidden",
        },
      }}
    >
      <InsurerInfoContentModal {...props}></InsurerInfoContentModal>
    </Modal>
  );
};

const InsurerInfoContentModal = (props) => {
  let dispatch = useDispatch();
  let coverid = 2;
  let insurercode = props?.code;
  const commentText = useSelector(
    getResponseDetailsFromInsurerCodeandCoverId({ coverid, insurercode })
  );
  let imgUrl =
    props.s3image?.Location ||
    process.env.REACT_APP_BASICSERVICE +
      "/static/media/insurers/" +
      insurercode +
      ".png";
  return (
    <PerfectScrollbar>
      <div className="container-fluid" style={{ backgroundColor: "#eef3f6" }}>
        <div className="ml-auto" style={{ float: "right" }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer" }}
            onClick={() => {
              dispatch(closeInsurerInfoModal());
            }}
          ></CancelIcon>
        </div>
        <div className="text-center">
          <img className="center" src={imgUrl}></img>
        </div>

        <div className="row ml-1 p-2">
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "1rem" }}
            >
              About {props?.name}
            </span>
          </div>
        </div>
        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
            marginBotton: "1vh",
          }}
        >
          <div
            className="col-10"
            style={{ fontSize: ".9rem", whiteSpace: "pre-line" }}
          >
            {props?.description}
          </div>
        </div>

        <div
          style={{
            marginTop: "3vh",
          }}
          className="row ml-1 p-2"
        >
          <div>
            <span
              className="text-center"
              style={{ fontFamily: "GibsonSemiBd", fontSize: "1rem" }}
            >
              Comments
            </span>
          </div>
        </div>
        <div
          className="row pt-3  justify-content-center"
          style={{
            fontFamily: "GibsonRegular",
            marginBotton: "1vh",
          }}
        >
          <div
            className="col-10"
            style={{ fontSize: ".9rem", whiteSpace: "pre-line" }}
          >
            {commentText}
          </div>
        </div>
        <div style={{ marginTop: "5vh" }} />
      </div>
    </PerfectScrollbar>
  );
};

export default MainArea;
